// extracted by mini-css-extract-plugin
export default {"btn":"listings_btn__PmDg0","attach":"listings_attach__A5dT7","headings":"listings_headings__Soyao","rows":"listings_rows__MMn24","enroll":"listings_enroll__cpILe"};